export let DateType = /*#__PURE__*/function (DateType) {
  DateType[DateType["DATE"] = 0] = "DATE";
  DateType[DateType["TIME"] = 1] = "TIME";
  DateType[DateType["DATE_TIME"] = 2] = "DATE_TIME";
  return DateType;
}({});
export let ToastType = /*#__PURE__*/function (ToastType) {
  ToastType[ToastType["NEUTRAL"] = 1] = "NEUTRAL";
  ToastType[ToastType["SUCCESS"] = 2] = "SUCCESS";
  ToastType[ToastType["WARNING"] = 3] = "WARNING";
  ToastType[ToastType["ERROR"] = 4] = "ERROR";
  return ToastType;
}({});
export let DialogInputType = /*#__PURE__*/function (DialogInputType) {
  DialogInputType["NUMBER"] = "number";
  DialogInputType["PASSWORD"] = "password";
  DialogInputType["TELEPHONE"] = "tel";
  DialogInputType["TEXT"] = "text";
  DialogInputType["TEXTAREA"] = "textarea";
  return DialogInputType;
}({});
export let DialogSelectType = /*#__PURE__*/function (DialogSelectType) {
  DialogSelectType[DialogSelectType["DEFAULT"] = 0] = "DEFAULT";
  DialogSelectType[DialogSelectType["ICON"] = 1] = "ICON";
  return DialogSelectType;
}({});
export let DialogButtonType = /*#__PURE__*/function (DialogButtonType) {
  DialogButtonType[DialogButtonType["OK"] = 1] = "OK";
  DialogButtonType[DialogButtonType["CANCEL"] = -1] = "CANCEL";
  DialogButtonType[DialogButtonType["NEGATIVE"] = 0] = "NEGATIVE";
  return DialogButtonType;
}({});
export let ScreenSize = /*#__PURE__*/function (ScreenSize) {
  ScreenSize[ScreenSize["XS"] = 0] = "XS";
  ScreenSize[ScreenSize["SM"] = 1] = "SM";
  ScreenSize[ScreenSize["MD"] = 2] = "MD";
  ScreenSize[ScreenSize["LG"] = 3] = "LG";
  ScreenSize[ScreenSize["XL"] = 4] = "XL";
  return ScreenSize;
}({});

/**
 * @ignore
 */

/**
 * @ignore
 */

export let AccessMode = /*#__PURE__*/function (AccessMode) {
  AccessMode[AccessMode["public"] = 0] = "public";
  AccessMode[AccessMode["protected"] = 1] = "protected";
  AccessMode[AccessMode["private"] = 2] = "private";
  return AccessMode;
}({});
export let ScanQrCodeCodeType = /*#__PURE__*/function (ScanQrCodeCodeType) {
  ScanQrCodeCodeType[ScanQrCodeCodeType["QR"] = 0] = "QR";
  ScanQrCodeCodeType[ScanQrCodeCodeType["BARCODE"] = 0] = "BARCODE";
  ScanQrCodeCodeType[ScanQrCodeCodeType["ALL"] = 2] = "ALL";
  return ScanQrCodeCodeType;
}({});
export let ScanQrCodeCameraTypes = /*#__PURE__*/function (ScanQrCodeCameraTypes) {
  ScanQrCodeCameraTypes[ScanQrCodeCameraTypes["AUTO"] = 0] = "AUTO";
  ScanQrCodeCameraTypes[ScanQrCodeCameraTypes["BACK"] = 1] = "BACK";
  ScanQrCodeCameraTypes[ScanQrCodeCameraTypes["FRONT"] = 2] = "FRONT";
  return ScanQrCodeCameraTypes;
}({});
var IOSFeedbackVibration = /*#__PURE__*/function (IOSFeedbackVibration) {
  IOSFeedbackVibration[IOSFeedbackVibration["Unknown"] = 0] = "Unknown";
  IOSFeedbackVibration[IOSFeedbackVibration["SelectionChanged"] = 1] = "SelectionChanged";
  IOSFeedbackVibration[IOSFeedbackVibration["NotificationError"] = 2] = "NotificationError";
  IOSFeedbackVibration[IOSFeedbackVibration["NotificationSuccess"] = 3] = "NotificationSuccess";
  IOSFeedbackVibration[IOSFeedbackVibration["NotificationWarning"] = 4] = "NotificationWarning";
  IOSFeedbackVibration[IOSFeedbackVibration["Light"] = 5] = "Light";
  IOSFeedbackVibration[IOSFeedbackVibration["Medium"] = 6] = "Medium";
  IOSFeedbackVibration[IOSFeedbackVibration["Heavy"] = 7] = "Heavy";
  IOSFeedbackVibration[IOSFeedbackVibration["Soft"] = 8] = "Soft";
  IOSFeedbackVibration[IOSFeedbackVibration["Rigid"] = 9] = "Rigid";
  return IOSFeedbackVibration;
}(IOSFeedbackVibration || {});
// region design settings
var SnapshotType = /*#__PURE__*/function (SnapshotType) {
  SnapshotType["Background"] = "background";
  SnapshotType["Settings"] = "settings";
  SnapshotType["ColorScheme"] = "colorScheme";
  SnapshotType["Cover"] = "cover";
  SnapshotType["Tapp"] = "tapp";
  return SnapshotType;
}(SnapshotType || {});
var DesignSettingsUpdateBackgroundType = /*#__PURE__*/function (DesignSettingsUpdateBackgroundType) {
  DesignSettingsUpdateBackgroundType[DesignSettingsUpdateBackgroundType["None"] = 0] = "None";
  DesignSettingsUpdateBackgroundType[DesignSettingsUpdateBackgroundType["Image"] = 1] = "Image";
  DesignSettingsUpdateBackgroundType[DesignSettingsUpdateBackgroundType["Video"] = 2] = "Video";
  DesignSettingsUpdateBackgroundType[DesignSettingsUpdateBackgroundType["Color"] = 3] = "Color";
  return DesignSettingsUpdateBackgroundType;
}(DesignSettingsUpdateBackgroundType || {});
var DesignSettingsUpdateSeasonTypes = /*#__PURE__*/function (DesignSettingsUpdateSeasonTypes) {
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["None"] = 0] = "None";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Snowm"] = 1] = "Snowm";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Confetti"] = 2] = "Confetti";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Leaf"] = 3] = "Leaf";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Heart"] = 4] = "Heart";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Balloon"] = 5] = "Balloon";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Eastern"] = 6] = "Eastern";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Clover"] = 7] = "Clover";
  DesignSettingsUpdateSeasonTypes[DesignSettingsUpdateSeasonTypes["Coins"] = 8] = "Coins";
  return DesignSettingsUpdateSeasonTypes;
}(DesignSettingsUpdateSeasonTypes || {});
var DesignSettingsUpdateGalleryAnimationTypes = /*#__PURE__*/function (DesignSettingsUpdateGalleryAnimationTypes) {
  DesignSettingsUpdateGalleryAnimationTypes[DesignSettingsUpdateGalleryAnimationTypes["Swipe"] = 0] = "Swipe";
  DesignSettingsUpdateGalleryAnimationTypes[DesignSettingsUpdateGalleryAnimationTypes["Fade"] = 1] = "Fade";
  DesignSettingsUpdateGalleryAnimationTypes[DesignSettingsUpdateGalleryAnimationTypes["Parallax"] = 2] = "Parallax";
  DesignSettingsUpdateGalleryAnimationTypes[DesignSettingsUpdateGalleryAnimationTypes["KenBurns"] = 3] = "KenBurns";
  return DesignSettingsUpdateGalleryAnimationTypes;
}(DesignSettingsUpdateGalleryAnimationTypes || {});
var DesignSettingsUpdateCoverTypes = /*#__PURE__*/function (DesignSettingsUpdateCoverTypes) {
  DesignSettingsUpdateCoverTypes[DesignSettingsUpdateCoverTypes["Image"] = 0] = "Image";
  DesignSettingsUpdateCoverTypes[DesignSettingsUpdateCoverTypes["Video"] = 1] = "Video";
  DesignSettingsUpdateCoverTypes[DesignSettingsUpdateCoverTypes["Slideshow"] = 2] = "Slideshow";
  DesignSettingsUpdateCoverTypes[DesignSettingsUpdateCoverTypes["Frame"] = 3] = "Frame";
  DesignSettingsUpdateCoverTypes[DesignSettingsUpdateCoverTypes["None"] = 4] = "None";
  return DesignSettingsUpdateCoverTypes;
}(DesignSettingsUpdateCoverTypes || {});
var DesignSettingsUpdateColorSchemeMode = /*#__PURE__*/function (DesignSettingsUpdateColorSchemeMode) {
  DesignSettingsUpdateColorSchemeMode[DesignSettingsUpdateColorSchemeMode["Normal"] = 0] = "Normal";
  DesignSettingsUpdateColorSchemeMode[DesignSettingsUpdateColorSchemeMode["Dark"] = 1] = "Dark";
  DesignSettingsUpdateColorSchemeMode[DesignSettingsUpdateColorSchemeMode["Bright"] = 2] = "Bright";
  return DesignSettingsUpdateColorSchemeMode;
}(DesignSettingsUpdateColorSchemeMode || {});
var DesignSettingsUpdateTappViewModes = /*#__PURE__*/function (DesignSettingsUpdateTappViewModes) {
  DesignSettingsUpdateTappViewModes[DesignSettingsUpdateTappViewModes["Normal"] = 0] = "Normal";
  DesignSettingsUpdateTappViewModes[DesignSettingsUpdateTappViewModes["Exclusive"] = 1] = "Exclusive";
  DesignSettingsUpdateTappViewModes[DesignSettingsUpdateTappViewModes["Wide"] = 2] = "Wide";
  DesignSettingsUpdateTappViewModes[DesignSettingsUpdateTappViewModes["Fullscreen"] = 3] = "Fullscreen";
  DesignSettingsUpdateTappViewModes[DesignSettingsUpdateTappViewModes["FullscreenWithBackground"] = 4] = "FullscreenWithBackground";
  return DesignSettingsUpdateTappViewModes;
}(DesignSettingsUpdateTappViewModes || {}); // endregion
var LoginState = /*#__PURE__*/function (LoginState) {
  LoginState[LoginState["FACEBOOK"] = 0] = "FACEBOOK";
  LoginState[LoginState["T_WEB"] = 1] = "T_WEB";
  LoginState[LoginState["LoginFailed"] = 2] = "LoginFailed";
  LoginState[LoginState["AlreadyLoggedIn"] = 3] = "AlreadyLoggedIn";
  LoginState[LoginState["SUCCESS"] = 4] = "SUCCESS";
  return LoginState;
}(LoginState || {});
export let FloatingButtonPosition = /*#__PURE__*/function (FloatingButtonPosition) {
  FloatingButtonPosition[FloatingButtonPosition["Right"] = 0] = "Right";
  FloatingButtonPosition[FloatingButtonPosition["Center"] = 1] = "Center";
  FloatingButtonPosition[FloatingButtonPosition["Left"] = 2] = "Left";
  return FloatingButtonPosition;
}({});
export let SharingApp = /*#__PURE__*/function (SharingApp) {
  SharingApp[SharingApp["Mail"] = 0] = "Mail";
  SharingApp[SharingApp["WhatsApp"] = 1] = "WhatsApp";
  SharingApp[SharingApp["Facebook"] = 2] = "Facebook";
  SharingApp[SharingApp["FacebookMessenger"] = 3] = "FacebookMessenger";
  SharingApp[SharingApp["GooglePlus"] = 4] = "GooglePlus";
  SharingApp[SharingApp["Twitter"] = 5] = "Twitter";
  return SharingApp;
}({});
export let TappEvent = /*#__PURE__*/function (TappEvent) {
  TappEvent[TappEvent["OnShow"] = 0] = "OnShow";
  TappEvent[TappEvent["OnHide"] = 1] = "OnHide";
  TappEvent[TappEvent["OnRefresh"] = 2] = "OnRefresh";
  TappEvent[TappEvent["OnOpenCcScanner"] = 3] = "OnOpenCcScanner";
  TappEvent[TappEvent["OnCloseCcScanner"] = 4] = "OnCloseCcScanner";
  return TappEvent;
}({});
export let IconType = /*#__PURE__*/function (IconType) {
  IconType[IconType["Font"] = 0] = "Font";
  IconType[IconType["Base64"] = 1] = "Base64";
  IconType[IconType["Url"] = 2] = "Url";
  return IconType;
}({});
export let Gender = /*#__PURE__*/function (Gender) {
  Gender[Gender["Unknown"] = 0] = "Unknown";
  Gender[Gender["male"] = 1] = "male";
  Gender[Gender["female"] = 2] = "female";
  Gender[Gender["diverse"] = 9] = "diverse";
  return Gender;
}({});
export let ColorMode = /*#__PURE__*/function (ColorMode) {
  ColorMode[ColorMode["Classic"] = 0] = "Classic";
  ColorMode[ColorMode["Dark"] = 1] = "Dark";
  ColorMode[ColorMode["Light"] = 2] = "Light";
  return ColorMode;
}({});
export let Language = /*#__PURE__*/function (Language) {
  Language["Unknown"] = "unknown";
  Language["German"] = "de";
  Language["English"] = "en";
  Language["Dutch"] = "nl";
  Language["French"] = "fr";
  Language["Spanish"] = "es";
  Language["Italian"] = "it";
  Language["Portuguese"] = "pt";
  Language["Turkish"] = "tr";
  Language["Polish"] = "pl";
  Language["Ukrainian"] = "uk";
  return Language;
}({});
export let RuntimeEnviroment = /*#__PURE__*/function (RuntimeEnviroment) {
  RuntimeEnviroment[RuntimeEnviroment["Unknown"] = 0] = "Unknown";
  RuntimeEnviroment[RuntimeEnviroment["ChaynsDe"] = 1] = "ChaynsDe";
  RuntimeEnviroment[RuntimeEnviroment["ChaynsWeb"] = 2] = "ChaynsWeb";
  RuntimeEnviroment[RuntimeEnviroment["ChaynsRuntime"] = 3] = "ChaynsRuntime";
  RuntimeEnviroment[RuntimeEnviroment["IntercomPlugin"] = 4] = "IntercomPlugin";
  RuntimeEnviroment[RuntimeEnviroment["PagemakerPlugin"] = 5] = "PagemakerPlugin";
  return RuntimeEnviroment;
}({});
export let DeviceOs = /*#__PURE__*/function (DeviceOs) {
  DeviceOs["Unknown"] = "unknown";
  DeviceOs["Android"] = "android";
  DeviceOs["IOS"] = "ios";
  DeviceOs["Windows"] = "windows";
  DeviceOs["MacOs"] = "macos";
  DeviceOs["Linux"] = "linux";
  return DeviceOs;
}({});
export let AppName = /*#__PURE__*/function (AppName) {
  AppName[AppName["Unknown"] = 0] = "Unknown";
  AppName[AppName["David"] = 1] = "David";
  AppName[AppName["Chayns"] = 2] = "Chayns";
  AppName[AppName["Location"] = 3] = "Location";
  AppName[AppName["Intercom"] = 4] = "Intercom";
  AppName[AppName["ChaynsLauncher"] = 5] = "ChaynsLauncher";
  return AppName;
}({});
export let BrowserName = /*#__PURE__*/function (BrowserName) {
  BrowserName["Unknown"] = "unknown";
  BrowserName["Chrome"] = "chrome";
  BrowserName["Safari"] = "safari";
  BrowserName["Firefox"] = "firefox";
  BrowserName["Edge"] = "edge";
  return BrowserName;
}({});
export let Environment = /*#__PURE__*/function (Environment) {
  Environment[Environment["Development"] = 0] = "Development";
  Environment[Environment["Qa"] = 1] = "Qa";
  Environment[Environment["Staging"] = 2] = "Staging";
  Environment[Environment["Production"] = 3] = "Production";
  return Environment;
}({});
export let Font = /*#__PURE__*/function (Font) {
  Font[Font["Unknown"] = 0] = "Unknown";
  Font[Font["Roboto"] = 1] = "Roboto";
  Font[Font["OpenSans"] = 2] = "OpenSans";
  Font[Font["Lato"] = 3] = "Lato";
  Font[Font["SourceSansPro"] = 4] = "SourceSansPro";
  Font[Font["Ubuntu"] = 5] = "Ubuntu";
  Font[Font["Cabin"] = 6] = "Cabin";
  Font[Font["Merriweather"] = 7] = "Merriweather";
  Font[Font["NotoSerif"] = 8] = "NotoSerif";
  Font[Font["PTSerif"] = 9] = "PTSerif";
  Font[Font["DroidSerif"] = 10] = "DroidSerif";
  Font[Font["Muli"] = 11] = "Muli";
  Font[Font["Poppins"] = 12] = "Poppins";
  Font[Font["RobotoCondensed"] = 13] = "RobotoCondensed";
  Font[Font["Anton"] = 14] = "Anton";
  Font[Font["ArchitectsDaughter"] = 15] = "ArchitectsDaughter";
  Font[Font["DMSerifDisplay"] = 16] = "DMSerifDisplay";
  Font[Font["Pacifico"] = 17] = "Pacifico";
  Font[Font["PermanentMarker"] = 18] = "PermanentMarker";
  Font[Font["Questrial"] = 19] = "Questrial";
  Font[Font["RobotoSlab"] = 20] = "RobotoSlab";
  Font[Font["ShadowsIntoLightTwo"] = 21] = "ShadowsIntoLightTwo";
  Font[Font["WaitingForTheSunrise"] = 22] = "WaitingForTheSunrise";
  Font[Font["RobotoMedium"] = 23] = "RobotoMedium";
  Font[Font["TobitHeadline"] = 24] = "TobitHeadline";
  Font[Font["RobotoBold"] = 25] = "RobotoBold";
  Font[Font["RobotoRegular"] = 26] = "RobotoRegular";
  Font[Font["Inter"] = 27] = "Inter";
  return Font;
}({});
var selectType = /*#__PURE__*/function (selectType) {
  selectType[selectType["DEFAULT"] = 0] = "DEFAULT";
  selectType[selectType["ICON"] = 1] = "ICON";
  return selectType;
}(selectType || {});
export let DialogType = /*#__PURE__*/function (DialogType) {
  DialogType["ALERT"] = "alert";
  DialogType["CONFIRM"] = "confirm";
  DialogType["DATE"] = "date";
  DialogType["FILE_SELECT"] = "fileSelect";
  DialogType["IFRAME"] = "iframe";
  DialogType["MODULE"] = "module";
  DialogType["INPUT"] = "input";
  DialogType["SELECT"] = "select";
  DialogType["TOAST"] = "toast";
  return DialogType;
}({});
export let MediaType = /*#__PURE__*/function (MediaType) {
  MediaType["IMAGE"] = "image";
  MediaType["VIDEO"] = "video";
  return MediaType;
}({});